export const stripInvalidMbiChars = (mbi: string) => {
    return (mbi || '').replace(/[^a-z0-9]/gi, '');
};